import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { trackError } from 'Utils/errorMonitoring';
import { Trans, useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';

export default function ImportFileError({ onClose, type, info }) {
    const { t } = useTranslation('common');

    const ERROR_TYPES = {
        // transactions errors
        // import_inconsistent_type: t("manual-bank.error-inconsistent-type"),
        // import_invalid_file: t("manual-bank.error-invalid-file"),
        // import_not_enough_rows: t("manual-bank.error-not-enough-rows"),
        // import_repeated_header: t("manual-bank.error-repeated-header"),
        // import_repeated_identifier: t("manual-bank.error-repeated-identifier"),
        too_many_rows: t('error-too-many-rows'),
        import_repeated_header: t('error-repeated-header'),
        import_deduplication_column_not_unique: t('error-deduplication-column-not-unique'),
        import_invalid_file: t('error-invalid-file', {
            row: info?.row, // optional (@TODO)
        }),
        import_not_enough_rows: t('error-not-enough-rows'),
        import_inconsistent_type: '',
    };

    useEffect(() => {
        const uncontrolledError = typeof ERROR_TYPES[type] === 'undefined';
        if (uncontrolledError) {
            if (typeof type === 'object') {
                trackError(type);
                return;
            }

            if (typeof type === 'string') {
                trackError(`Uncontrolled import error: ${type}`);
                return;
            }

            trackError('Uncontrolled import error');
        }
    }, [type]);

    const getMessage = () => {
        if (type === 'import_inconsistent_type') {
            const i18nKey = info?.expected_format
                ? 'error-inconsistent-type-description-no-format'
                : 'error-inconsistent-type-description';

            const value = {
                value: info?.value,
                row: info?.row,
                column: info?.column,
                expected_type: info?.expected_type,
                expected_format: info?.expected_format,
            };

            return (
                <Trans t={t} i18nKey={i18nKey}>
                    {{ value }}
                </Trans>
            );
        }

        return ERROR_TYPES[type] ?? t('error-import-unknown');
    };

    return (
        <div className="text-center py-10">
            <div className="flex justify-center mb-4">
                <img src="/img/icon-error.svg" alt="" />
            </div>
            <div className="font-semibold text-lg">{t('error-importing')}</div>
            <div className="text-gray-500">{getMessage()}</div>
            <div className="mt-4 flex justify-center">
                <Button variant="primary" onClick={onClose}>
                    {t('accept')}
                </Button>
            </div>
        </div>
    );
}

ImportFileError.propTypes = {
    onClose: PropTypes.func.isRequired,
    type: PropTypes.any,
    info: PropTypes.object,
};
